/** SUB_GOAL_LBS_LBS */
export const SUB_GOAL_LBS_BY_CLIENT = 'SUB_GOAL_LBS_BY_CLIENT';
export const SUB_GOAL_LBS_BY_CLIENT_SUCCESS = 'SUB_GOAL_LBS_BY_CLIENT_SUCCESS';
export const SUB_GOAL_LBS_BY_CLIENT_ERROR = 'SUB_GOAL_LBS_BY_CLIENT_ERROR';

export const SUB_GOAL_LBS_ADD_NEW = 'SUB_GOAL_LBS_ADD_NEW';
export const SUB_GOAL_LBS_ADD_NEW_ERROR = 'SUB_GOAL_LBS_ADD_NEW_ERROR';

export const SUB_GOAL_LBS_NOTIFICATION_CLOSED = 'SUB_GOAL_LBS_NOTIFICATION_CLOSED';
